export default "__VITE_ASSET__BFaC48$d__"